// extracted by mini-css-extract-plugin
export default {"included":"Included_included__5X3NV","heading":"Included_heading__w+RxC","container":"Included_container__6l0Nt"};